import React from 'react';

import { Box, Flex, Text, Icon } from '@chakra-ui/react';
import { HiStar } from 'react-icons/hi';

interface QuotesCardProps {
    quote: string;
    rating: number;
    name: string;
}

export default function QuotesCard({ quote, rating, name }: QuotesCardProps) {
    return (
        <Box
            bg="#1F2937"
            borderRadius="6px"
            py={{ base: 6, md: 8 }}
            px={{ base: 4, md: 6 }}
            maxW={{ base: '100%', sm: '100%', md: 'sm' }}
            color="white"
            boxShadow="0 4px 6px 0 rgba(0, 0, 0, 0.04)"
        >
            <Text
                color="#F3F4F6"
                fontSize={{ base: '16px', md: '18px' }}
                lineHeight={{ base: '26px', md: '28px' }}
                mb={4}
                fontWeight="500"
            >
                &quot;{quote}&quot;
            </Text>

            <Flex mb={2}>
                {Array(5)
                    .fill(null)
                    .map((_, index) => (
                        <Icon
                            key={index}
                            as={HiStar}
                            color={index < Math.round(rating) ? 'yellow.400' : 'gray.600'}
                            boxSize="22px"
                            mr={1}
                        />
                    ))}
            </Flex>

            <Text
                fontSize={{ base: '14px', md: '16px' }}
                color="#FFFFFF"
                lineHeight={{ base: '22px', md: '24px' }}
                fontWeight="400"
            >
                {name}
            </Text>
        </Box>
    );
}
